import { Component, OnInit } from "@angular/core";
import { NotificationService } from "../../@core/api/notification.service";
import { Notification } from "../../@core/data/notification";

@Component({
  selector: "ngx-notifications",
  templateUrl: "./notifications.component.html",
  styleUrls: ["./notifications.component.scss"],
})
export class NotificationsComponent implements OnInit {
  notifications: Notification[] = [];
  loading: boolean = true;

  constructor(private notificationService: NotificationService) {}

  async ngOnInit() {
    this.getNotifications();
  }

  async getNotifications() {
    this.loading = true;
    this.notifications = <Notification[]>(
      await this.notificationService.getNotifications()
    );
    this.loading = false;
  }
}
